import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AreaCenter } from 'src/app/interfaces/area-center';
import { AreaCenterService } from 'src/app/services/area-center.service';
import { ErrorService } from 'src/app/services/error.service';

@Component({
  selector: 'app-area-center',
  templateUrl: './area-center.component.html',
  styleUrls: ['./area-center.component.css']
})
export class AreaCenterComponent implements OnInit {
  listAreaCenters: AreaCenter[] = [];
  loading = false;

  constructor(
    private _areacenterService: AreaCenterService,
    private toastr: ToastrService,
    private _errorService: ErrorService
  ) {}

  ngOnInit(): void {
    this.getListAreaCenters();
  }

  getListAreaCenters() {
    this.loading = true;
    this._areacenterService.getListAreaCenters().subscribe({
      next: (data: AreaCenter[]) => {
        this.listAreaCenters = data;
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al obtener la lista de areas de centros:', error);
        this._errorService.msjError(error);
        this.loading = false;
      }
    });
  }

  deleteAreaCenter(id: number) {
    this.loading = true;
    this._areacenterService.deleteAreaCenter(id).subscribe({
      next: () => {
        this.getListAreaCenters();
        this.toastr.warning('El area-centro fue eliminado con exito', 'Area-centro eliminado');
      },
      error: (error) => {
        console.error('Error al eliminar el area-centro:', error);
        this._errorService.msjError(error);
        this.loading = false;
      }
    });
  }
}
